document.addEventListener("DOMContentLoaded", () => {
    // 1. Detect Shopify Locale (Defaults to 'de')
    const currentLang = (window.Shopify && window.Shopify.locale) ? window.Shopify.locale : 'de';

    // 2. The Translation Dictionary
    const i18n = {
        en: {
            next: "Continue",
            back: "← Back",
            stepIndicator: (c, tt) => `Step ${c} of 6`,
            stepOf: (c, name) => `Step ${c} of 6 · ${name}`,
            themeTitle: (x) => x ? `Theme: ${x}` : 'Your book is being personalized...',
            steps: ["Your child", "Photo", "Preview", "Cover", "Extras", "More books"],

            // Phase 1
            p1Heading: "Who is this book for?",
            p1Lede: "Just three quick questions.",
            firstName: "What is your child's first name?",
            namePlaceholder: "e.g., Emma",
            genderLabel: "Is your child a boy or a girl?",
            boy: "Boy",
            girl: "Girl",
            eyeColorLabel: "What colour are their eyes?",
            langLabel: "Which language should the book be in?",
            eyes: { light_blue: "Light Blue", blue: "Blue", green: "Green", hazel: "Hazel", brown: "Brown", dark_brown: "Dark Brown", gray: "Gray" },

            // Phase 2
            p2Heading: (n) => `Now add a photo of ${n}`,
            p2Lede: "One clear photo of the face is all we need.",
            selectPhoto: "Choose a photo",
            dragDrop: "or drag a photo here",
            photoAdded: "Photo added — tap to choose a different one",
            consent: "I have the right to use this photo. Details in the privacy policy.",
            tipsToggle: "See photo tips",
            writeOwn: "Or write your own message",
            tipsHeading: "What makes a good photo?",
            tipsSub: "The face should be clearly visible — no hats, pacifiers, sunglasses or funny faces.",
            tipSharp: "Do this",
            tipMultiple: "Not this",
            alertInvalid: "Please upload a valid image (JPG, PNG).",

            // Phase 3
            p3Heading: "Creating your preview...",
            p3Sub: "This usually takes about 30 seconds. Please keep this page open.",
            takesTime: "About 30 seconds",
            socialProof: "Over 3,000 books created",
            loadingStrings: ["Creating your preview...", "Almost there, just a moment...", "Your adventure is taking shape...", "We're bringing your hero to life...", "Your magic is almost ready..."],

            // Phase 4
            p4Heading: "Here is your preview",
            previewDesc: "This is your child's character and the first page. After you order, we add the character to every page of the book.",
            p4HeadingFallback: "Something went wrong",
            p4LedeFallback: "We couldn't create your child's preview this time. You can try again with a different photo, or continue — our design team will create it by hand and email it to you before printing.",
            capCharacter: "Your child's character",
            capInside: "The first page of the book",
            details: "What's in the book?",
            specs: ["32 Pages", "21 x 21 cm", "360° Layflat Technology", "Printed in Europe", "Perfect for ages 1-12", "High-quality illustrations", "Durable materials", "Printed in 2-4 days"],
            remainingPages: "The other 34 pages are waiting for you. After you order, our design team adds your character to every single scene.",
            uploadDifferent: "Try a different photo",

            // Phase 5
            p5Heading: "Which cover would you like?",
            p5Lede: "Same 32 pages inside — just tap one to choose.",
            mostPopular: "Most popular",
            hardcover: "Hardcover",
            hardcoverDesc: "Sturdy and made to last for years of reading.",
            selectBtn: "Choose this",
            softcover: "Softcover",
            softcoverDesc: "Light and flexible — great for little hands.",

            // Phase 6
            p6Heading: "Anything to add?",
            p6Lede: "Both are optional — you can skip this step.",
            dedicationHeading: "Personal message",
            popularChoice: "75% add this",
            dedicationDesc: "Your words printed on the first page.",
            addDedication: "Add a personal message",
            tabPick: "Choose a message",
            tabOwn: "Write my own",
            dedicationPlaceholder: (n) => `Write your own message for ${n}...`,
            charsLeft: "characters left",
            readyMadeText: "Pick a message, or write your own below:",
            msg1: (n) => `Dear ${n}, Grandma and Grandpa wish you a very happy birthday! Have fun on your big adventure.`,
            msg2: (n) => `Happy Birthday, ${n}! We love you endlessly. Enjoy your magical story.`,
            msg3: (n) => `To our little hero, ${n}. Always stay so brave, kind, and full of curiosity.`,
            posterHeading: "Matching poster",
            posterDesc: "A print of your child's character, ready to frame.",
            comingSoon: "Coming soon",
            comingSoonNote: "We're working on it — it will appear here as soon as it's ready.",

            // Phase 7
            loadingOffers: "One moment...",
            checkingShelves: "We're looking for other books your child might like.",
            readyCheckout: "You're all set!",
            continueCart: "Go to cart",
            fancyAnother: "Add another book?",
            fancySub: "Same child, a new story. You can skip this — your book is ready.",
            dealNote: "Add a 2nd book and save 25%. From the 3rd book, save 40%.",
            from3rd: "From 3rd Book",
            save40: "Save 40%",
            freeShipping: "Free Shipping",
            bestPrice: "Best Price",
            book2: "2nd Book",
            save25: "Save 25%",
            book1: "1 Book",
            youSave: "YOU SAVE:",
            bundleHeading: "Fancy another adventure?",
            bundleSub: "Same child, new story - name and appearance stay the same.",
            selectCheck: "Add",
            addToCart: "Add to cart",
            processing: "Please wait...",
            cartError: "Cart Error: "
        },
        de: {
            next: "Weiter", back: "← Zurück", stepIndicator: (c) => `Schritt ${c} von 6`, stepOf: (c, name) => `Schritt ${c} von 6 · ${name}`,
            themeTitle: (x) => x ? `Thema: ${x}` : 'Dein Buch wird personalisiert...',
            steps: ["Dein Kind", "Foto", "Vorschau", "Cover", "Extras", "Mehr Bücher"],
            p1Heading: "Für wen ist dieses Buch?", p1Lede: "Nur drei kurze Fragen.",
            firstName: "Wie heißt dein Kind mit Vornamen?", namePlaceholder: "z.B. Emma",
            genderLabel: "Ist dein Kind ein Junge oder ein Mädchen?", boy: "Junge", girl: "Mädchen",
            eyeColorLabel: "Welche Augenfarbe hat dein Kind?", langLabel: "In welcher Sprache soll das Buch sein?",
            eyes: { light_blue: "Hellblau", blue: "Blau", green: "Grün", hazel: "Haselnuss", brown: "Braun", dark_brown: "Dunkelbraun", gray: "Grau" },
            p2Heading: (n) => `Jetzt ein Foto von ${n} hinzufügen`, p2Lede: "Ein klares Foto vom Gesicht genügt.",
            selectPhoto: "Foto auswählen", dragDrop: "oder Foto hierhin ziehen", photoAdded: "Foto hinzugefügt — tippe für ein anderes Foto",
            consent: "Ich habe das Recht, dieses Foto zu verwenden. Details in der Datenschutzerklärung.",
            tipsToggle: "Foto-Tipps ansehen", writeOwn: "Oder schreibe deine eigene Widmung",
            tipsHeading: "Was ist ein gutes Foto?", tipsSub: "Das Gesicht sollte gut sichtbar sein — keine Hüte, Schnuller, Sonnenbrillen oder Grimassen.",
            tipSharp: "So ja", tipMultiple: "So nicht", alertInvalid: "Bitte lade ein gültiges Bild hoch (JPG, PNG).",
            p3Heading: "Deine Vorschau wird erstellt...", p3Sub: "Das dauert etwa 30 Sekunden. Bitte lass diese Seite offen.",
            takesTime: "Etwa 30 Sekunden", socialProof: "Über 3.000 Bücher erstellt",
            loadingStrings: ["Deine Vorschau wird erstellt...", "Fast fertig, nur noch einen Moment...", "Dein Abenteuer nimmt Gestalt an...", "Wir erwecken deinen Helden zum Leben...", "Deine Magie ist fast bereit..."],
            p4Heading: "Hier ist deine Vorschau", previewDesc: "Das ist der Charakter deines Kindes und die erste Seite. Nach der Bestellung fügen wir den Charakter in jede Seite ein.",
            p4HeadingFallback: "Etwas ist schiefgelaufen", p4LedeFallback: "Wir konnten die Vorschau diesmal nicht erstellen. Du kannst es mit einem anderen Foto erneut versuchen oder fortfahren — unser Design-Team erstellt sie von Hand und schickt sie dir vor dem Druck per E-Mail.",
            capCharacter: "Der Charakter deines Kindes", capInside: "Die erste Seite im Buch",
            details: "Was steckt im Buch?", specs: ["32 Seiten", "21 x 21 cm", "360° Layflat-Technologie", "Gedruckt in Europa", "Perfekt für 1-12 Jahre", "Hochwertige Illustrationen", "Langlebige Materialien", "Gedruckt in 2-4 Tagen"],
            remainingPages: "Die restlichen 34 Seiten warten auf dich. Nach der Bestellung fügt unser Design-Team deinen Charakter in jede Szene ein.",
            uploadDifferent: "Anderes Foto probieren",
            p5Heading: "Welches Cover möchtest du?", p5Lede: "Innen die gleichen 32 Seiten — tippe einfach auf eins.",
            mostPopular: "Am beliebtesten", hardcover: "Hardcover", hardcoverDesc: "Stabil und gemacht für viele Jahre Vorlesen.",
            selectBtn: "Das nehmen", softcover: "Softcover", softcoverDesc: "Leicht und flexibel — ideal für kleine Hände.",
            p6Heading: "Möchtest du etwas hinzufügen?", p6Lede: "Beides ist optional — du kannst diesen Schritt überspringen.",
            dedicationHeading: "Persönliche Widmung", popularChoice: "75% wählen das", dedicationDesc: "Deine Worte auf der ersten Seite gedruckt.",
            addDedication: "Widmung hinzufügen", tabPick: "Widmung wählen", tabOwn: "Selbst schreiben", dedicationPlaceholder: (n) => `Schreibe deine eigene Widmung für ${n}...`,
            charsLeft: "Zeichen übrig", readyMadeText: "Wähle eine Widmung oder schreibe unten deine eigene:",
            msg1: (n) => `Liebe(r) ${n}, Oma und Opa wünschen dir alles Gute zum Geburtstag! Viel Spaß bei deinem großen Abenteuer.`,
            msg2: (n) => `Alles Gute zum Geburtstag, ${n}! Wir lieben dich unendlich. Genieße deine magische Geschichte.`,
            msg3: (n) => `Für unseren kleinen Helden, ${n}. Bleib immer so mutig, freundlich und voller Neugier.`,
            posterHeading: "Passendes Poster", posterDesc: "Ein Druck vom Charakter deines Kindes, fertig zum Rahmen.", comingSoon: "Demnächst", comingSoonNote: "Wir arbeiten daran — sobald es fertig ist, erscheint es hier.",
            loadingOffers: "Einen Moment...", checkingShelves: "Wir suchen weitere Bücher, die deinem Kind gefallen könnten.",
            readyCheckout: "Alles bereit!", continueCart: "Zum Warenkorb",
            fancyAnother: "Noch ein Buch dazu?", fancySub: "Gleiches Kind, neue Geschichte. Du kannst das überspringen — dein Buch ist fertig.",
            dealNote: "Beim 2. Buch 25% sparen. Ab dem 3. Buch 40% sparen.",
            from3rd: "Ab dem 3. Buch", save40: "40% sparen", freeShipping: "Kostenloser Versand", bestPrice: "Bester Preis",
            book2: "2. Buch", save25: "25% sparen", book1: "1 Buch", youSave: "DU SPARST:",
            bundleHeading: "Lust auf ein weiteres Abenteuer?", bundleSub: "Gleiches Kind, neue Geschichte - Name und Aussehen bleiben gleich.",
            selectCheck: "Hinzufügen", addToCart: "In den Warenkorb", processing: "Bitte warten...", cartError: "Warenkorb Fehler: "
        },
        fr: {
            next: "Continuer", back: "← Retour", stepIndicator: (c) => `Étape ${c} sur 6`, stepOf: (c, name) => `Étape ${c} sur 6 · ${name}`,
            themeTitle: (x) => x ? `Thème: ${x}` : 'Votre livre est en cours de personnalisation...',
            steps: ["Votre enfant", "Photo", "Aperçu", "Couverture", "Options", "Autres livres"],
            p1Heading: "Pour qui est ce livre ?", p1Lede: "Seulement trois petites questions.",
            firstName: "Quel est le prénom de votre enfant ?", namePlaceholder: "ex. Emma",
            genderLabel: "Votre enfant est un garçon ou une fille ?", boy: "Garçon", girl: "Fille",
            eyeColorLabel: "De quelle couleur sont ses yeux ?", langLabel: "Dans quelle langue le livre doit-il être ?",
            eyes: { light_blue: "Bleu clair", blue: "Bleu", green: "Vert", hazel: "Noisette", brown: "Marron", dark_brown: "Marron foncé", gray: "Gris" },
            p2Heading: (n) => `Ajoutez une photo de ${n}`, p2Lede: "Une photo nette du visage suffit.",
            selectPhoto: "Choisir une photo", dragDrop: "ou glissez une photo ici", photoAdded: "Photo ajoutée — touchez pour en choisir une autre",
            consent: "J'ai le droit d'utiliser cette photo. Détails dans la politique de confidentialité.",
            tipsToggle: "Voir les conseils photo", writeOwn: "Ou écrivez votre propre message",
            tipsHeading: "Qu'est-ce qu'une bonne photo ?", tipsSub: "Le visage doit être bien visible — sans chapeau, tétine, lunettes de soleil ou grimaces.",
            tipSharp: "Comme ça", tipMultiple: "Pas comme ça", alertInvalid: "Veuillez télécharger une image valide (JPG, PNG).",
            p3Heading: "Création de votre aperçu...", p3Sub: "Cela prend environ 30 secondes. Merci de garder cette page ouverte.",
            takesTime: "Environ 30 secondes", socialProof: "Plus de 3 000 livres créés",
            loadingStrings: ["Création de votre aperçu...", "Presque terminé, encore un instant...", "Votre aventure prend forme...", "Nous donnons vie à votre héros...", "Votre magie est presque prête..."],
            p4Heading: "Voici votre aperçu", previewDesc: "Voici le personnage de votre enfant et la première page. Après la commande, nous l'ajoutons à toutes les pages.",
            p4HeadingFallback: "Un problème est survenu", p4LedeFallback: "Nous n'avons pas pu créer l'aperçu cette fois-ci. Vous pouvez réessayer avec une autre photo, ou continuer — notre équipe le créera à la main et vous l'enverra par e-mail avant l'impression.",
            capCharacter: "Le personnage de votre enfant", capInside: "La première page du livre",
            details: "Que contient le livre ?", specs: ["32 Pages", "21 x 21 cm", "Technologie Layflat 360°", "Imprimé en Europe", "Parfait pour les 1-12 ans", "Illustrations de haute qualité", "Matériaux durables", "Imprimé en 2-4 jours"],
            remainingPages: "Les 34 autres pages vous attendent. Après la commande, notre équipe ajoute votre personnage à chaque scène.",
            uploadDifferent: "Essayer une autre photo",
            p5Heading: "Quelle couverture souhaitez-vous ?", p5Lede: "Les mêmes 32 pages à l'intérieur — touchez pour choisir.",
            mostPopular: "Le plus populaire", hardcover: "Couverture rigide", hardcoverDesc: "Solide et conçue pour durer des années.",
            selectBtn: "Choisir", softcover: "Couverture souple", softcoverDesc: "Légère et flexible — idéale pour les petites mains.",
            p6Heading: "Souhaitez-vous ajouter quelque chose ?", p6Lede: "Tout est optionnel — vous pouvez passer cette étape.",
            dedicationHeading: "Message personnel", popularChoice: "75% l'ajoutent", dedicationDesc: "Vos mots imprimés sur la première page.",
            addDedication: "Ajouter un message", tabPick: "Choisir un message", tabOwn: "Écrire le mien", dedicationPlaceholder: (n) => `Écrivez votre propre message pour ${n}...`,
            charsLeft: "caractères restants", readyMadeText: "Choisissez un message, ou écrivez le vôtre ci-dessous :",
            msg1: (n) => `Cher/Chère ${n}, Papy et Mamie te souhaitent un très joyeux anniversaire ! Amuse-toi bien dans ta grande aventure.`,
            msg2: (n) => `Joyeux anniversaire, ${n} ! Nous t'aimons à l'infini. Profite de ton histoire magique.`,
            msg3: (n) => `À notre petit héros, ${n}. Reste toujours aussi courageux, gentil et curieux.`,
            posterHeading: "Poster assorti", posterDesc: "Une impression du personnage de votre enfant, prête à encadrer.", comingSoon: "Bientôt disponible", comingSoonNote: "Nous y travaillons — il apparaîtra ici dès qu'il sera prêt.",
            loadingOffers: "Un instant...", checkingShelves: "Nous cherchons d'autres livres qui pourraient plaire.",
            readyCheckout: "Tout est prêt !", continueCart: "Aller au panier",
            fancyAnother: "Ajouter un autre livre ?", fancySub: "Même enfant, nouvelle histoire. Vous pouvez passer — votre livre est prêt.",
            dealNote: "2ème livre : -25%. À partir du 3ème livre : -40%.",
            from3rd: "Dès le 3ème livre", save40: "Économisez 40%", freeShipping: "Livraison gratuite", bestPrice: "Meilleur Prix",
            book2: "2ème livre", save25: "Économisez 25%", book1: "1 Livre", youSave: "VOUS ÉCONOMISEZ :",
            bundleHeading: "Envie d'une autre aventure ?", bundleSub: "Même enfant, nouvelle histoire - le nom et l'apparence restent les mêmes.",
            selectCheck: "Ajouter", addToCart: "Ajouter au panier", processing: "Un instant...", cartError: "Erreur de panier : "
        },
        nl: {
            next: "Verder", back: "← Terug", stepIndicator: (c) => `Stap ${c} van 6`, stepOf: (c, name) => `Stap ${c} van 6 · ${name}`,
            themeTitle: (x) => x ? `Thema: ${x}` : 'Je boek wordt gepersonaliseerd...',
            steps: ["Je kind", "Foto", "Voorbeeld", "Kaft", "Extra's", "Meer boeken"],
            p1Heading: "Voor wie is dit boek?", p1Lede: "Slechts drie korte vragen.",
            firstName: "Wat is de voornaam van je kind?", namePlaceholder: "bijv. Emma",
            genderLabel: "Is je kind een jongen of een meisje?", boy: "Jongen", girl: "Meisje",
            eyeColorLabel: "Welke oogkleur heeft je kind?", langLabel: "In welke taal moet het boek zijn?",
            eyes: { light_blue: "Lichtblauw", blue: "Blauw", green: "Groen", hazel: "Hazelnoot", brown: "Bruin", dark_brown: "Donkerbruin", gray: "Grijs" },
            p2Heading: (n) => `Voeg nu een foto van ${n} toe`, p2Lede: "Eén duidelijke foto van het gezicht is genoeg.",
            selectPhoto: "Kies een foto", dragDrop: "of sleep een foto hierheen", photoAdded: "Foto toegevoegd — tik voor een andere foto",
            consent: "Ik heb het recht om deze foto te gebruiken. Details in het privacybeleid.",
            tipsToggle: "Bekijk fototips", writeOwn: "Of schrijf je eigen tekst",
            tipsHeading: "Wat is een goede foto?", tipsSub: "Het gezicht moet goed zichtbaar zijn — geen hoeden, fopspenen, zonnebrillen of grimassen.",
            tipSharp: "Zo wel", tipMultiple: "Zo niet", alertInvalid: "Upload een geldig bestand (JPG, PNG).",
            p3Heading: "Je voorbeeld wordt gemaakt...", p3Sub: "Dit duurt ongeveer 30 seconden. Houd deze pagina open.",
            takesTime: "Ongeveer 30 seconden", socialProof: "Meer dan 3.000 boeken gemaakt",
            loadingStrings: ["Je voorbeeld wordt gemaakt...", "Bijna klaar, nog even geduld...", "Je avontuur krijgt vorm...", "We brengen je held tot leven...", "Je magie is bijna klaar..."],
            p4Heading: "Hier is je voorbeeld", previewDesc: "Dit is het personage van je kind en de eerste pagina. Na je bestelling voegen we het personage aan elke pagina toe.",
            p4HeadingFallback: "Er ging iets mis", p4LedeFallback: "We konden je voorbeeld deze keer niet maken. Je kunt het opnieuw proberen met een andere foto, of doorgaan — ons designteam maakt het met de hand en mailt het je vóór het drukken.",
            capCharacter: "Het personage van je kind", capInside: "De eerste pagina van het boek",
            details: "Wat zit er in het boek?", specs: ["32 Pagina's", "21 x 21 cm", "360° Layflat-technologie", "Gedrukt in Europa", "Perfect voor 1-12 jaar", "Hoogwaardige illustraties", "Duurzame materialen", "Gedrukt in 2-4 dagen"],
            remainingPages: "De overige 34 pagina's wachten op je. Na je bestelling voegt ons designteam je personage aan elke scène toe.",
            uploadDifferent: "Andere foto proberen",
            p5Heading: "Welke kaft wil je?", p5Lede: "Dezelfde 32 pagina's binnenin — tik er een aan.",
            mostPopular: "Meest gekozen", hardcover: "Hardcover", hardcoverDesc: "Stevig en gemaakt om jaren mee te gaan.",
            selectBtn: "Deze kiezen", softcover: "Softcover", softcoverDesc: "Licht en flexibel — fijn voor kleine handjes.",
            p6Heading: "Wil je nog iets toevoegen?", p6Lede: "Beide zijn optioneel — je kunt deze stap overslaan.",
            dedicationHeading: "Persoonlijke boodschap", popularChoice: "75% kiest dit", dedicationDesc: "Jouw woorden op de eerste pagina gedrukt.",
            addDedication: "Boodschap toevoegen", tabPick: "Kies een tekst", tabOwn: "Zelf schrijven", dedicationPlaceholder: (n) => `Schrijf je eigen boodschap voor ${n}...`,
            charsLeft: "tekens over", readyMadeText: "Kies een tekst, of schrijf hieronder je eigen:",
            msg1: (n) => `Lieve ${n}, opa en oma wensen je een hele fijne verjaardag! Veel plezier op je grote avontuur.`,
            msg2: (n) => `Gefeliciteerd, ${n}! We houden oneindig veel van je. Geniet van je magische verhaal.`,
            msg3: (n) => `Voor onze kleine held, ${n}. Blijf altijd zo dapper, lief en vol nieuwsgierigheid.`,
            posterHeading: "Bijpassende poster", posterDesc: "Een print van het personage van je kind, klaar om in te lijsten.", comingSoon: "Binnenkort", comingSoonNote: "We werken eraan — zodra het klaar is, verschijnt het hier.",
            loadingOffers: "Een moment...", checkingShelves: "We zoeken andere boeken die je kind leuk vindt.",
            readyCheckout: "Alles klaar!", continueCart: "Naar winkelwagen",
            fancyAnother: "Nog een boek erbij?", fancySub: "Zelfde kind, nieuw verhaal. Je kunt dit overslaan — je boek is klaar.",
            dealNote: "2e boek 25% korting. Vanaf het 3e boek 40% korting.",
            from3rd: "Vanaf 3e boek", save40: "Bespaar 40%", freeShipping: "Gratis verzending", bestPrice: "Beste Prijs",
            book2: "2e boek", save25: "Bespaar 25%", book1: "1 Boek", youSave: "JE BESPAART:",
            bundleHeading: "Zin in nog een avontuur?", bundleSub: "Zelfde kind, nieuw verhaal - naam en uiterlijk blijven gelijk.",
            selectCheck: "Toevoegen", addToCart: "In winkelwagen", processing: "Even geduld...", cartError: "Winkelwagen Fout: "
        }
    };

    // 3. Set Active Language Fallback
    const t = i18n[currentLang] || i18n['de'];
    const root = document.getElementById("book-funnel-root");
    if (!root) return;
    document.body.classList.add('funnel-active');

    const n8nWebhook = window.bookFunnelConfig ? window.bookFunnelConfig.webhookUrl : "";

    function forceScrollToTop() {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        setTimeout(() => {
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        }, 50);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const themeName = urlParams.get('theme');
    const dynamicBaseId = urlParams.get('baseId');

    const themeTitleEl = document.getElementById('dynamic-theme-title');
    if (themeTitleEl) themeTitleEl.innerText = t.themeTitle(themeName);

    /* ---- Remember where the shopper came from, so the X can return there ----
       Two traps this has to avoid:
       1. After a reload, document.referrer is the funnel's own URL.
       2. The theme runs {% render 'geo-redirect' %}, which bounces
          /pages/personalize -> /en/pages/personalize. That makes the referrer
          the SAME page with a different locale prefix, so a plain pathname
          comparison thinks it's a different page and you end up right back here.
       So paths are compared with the locale prefix stripped off.
       You can always force a destination with ?return=/collections/whatever  */
    const RETURN_KEY = 'funnel_return_url';

    // "/en/pages/personalize" and "/de-ch/pages/personalize" -> "/pages/personalize"
    function stripLocale(pathname) {
        return pathname.replace(/^\/[a-z]{2}(-[a-z]{2,4})?(?=\/|$)/i, '') || '/';
    }
    function isSameFunnelPage(url) {
        try {
            const u = (url instanceof URL) ? url : new URL(url, window.location.origin);
            return stripLocale(u.pathname) === stripLocale(window.location.pathname);
        } catch (e) { return false; }
    }

    (function rememberEntryPoint() {
        const explicitReturn = urlParams.get('return');
        if (explicitReturn && !isSameFunnelPage(explicitReturn)) {
            sessionStorage.setItem(RETURN_KEY, explicitReturn);
            return;
        }
        if (sessionStorage.getItem(RETURN_KEY)) return; // already captured this session

        const ref = document.referrer;
        if (!ref) return;
        try {
            const refUrl = new URL(ref);
            if (refUrl.host !== window.location.host) return; // off-site
            if (isSameFunnelPage(refUrl)) return;             // the funnel itself
            sessionStorage.setItem(RETURN_KEY, ref);
        } catch (e) { /* malformed referrer — ignore */ }
    })();

    const closeFunnelBtn = document.getElementById('funnel-close-btn');
    if (closeFunnelBtn) {
        closeFunnelBtn.addEventListener('click', () => {
            const returnUrl = sessionStorage.getItem(RETURN_KEY);

            // never navigate back to this same page (any locale of it)
            if (returnUrl && !isSameFunnelPage(returnUrl)) {
                sessionStorage.removeItem(RETURN_KEY);
                window.location.href = returnUrl;
                return;
            }

            sessionStorage.removeItem(RETURN_KEY);

            if (window.history.length > 1) {
                window.history.back();
                return;
            }

            // last resort: the shop's home page, keeping the current locale
            const localePrefix = window.location.pathname.match(/^\/[a-z]{2}(-[a-z]{2,4})?(?=\/|$)/i);
            window.location.href = localePrefix ? localePrefix[0] + '/' : '/';
        });
    }

    /* ---------------- Notification ticker (capitals) ---------------- */
    const notificationEl = document.querySelector('.notification-text');
    if (notificationEl) {
        let notificationMessages = [];
        if (currentLang === 'de') {
            notificationMessages = [
                "Jemand aus Wien hat gerade Prinzessin bestellt",
                "Jemand aus Berlin hat gerade 2 Bücher bestellt",
                "Jemand aus Bern hat gerade Superheld bestellt",
                "Jemand aus Luxemburg hat gerade 3 Bücher bestellt"
            ];
        } else if (currentLang === 'fr') {
            notificationMessages = [
                "Quelqu'un de Bruxelles vient de commander Princesse",
                "Quelqu'un de Paris vient de commander 2 livres",
                "Quelqu'un de Berne vient de commander Superhéros",
                "Quelqu'un de Luxembourg vient de commander 3 livres"
            ];
        } else if (currentLang === 'nl') {
            notificationMessages = [
                "Iemand uit Amsterdam heeft zojuist Prinses besteld",
                "Iemand uit Brussel heeft zojuist 2 boeken besteld",
                "Iemand uit Den Haag heeft zojuist Superheld besteld",
                "Iemand uit Luxemburg heeft zojuist 3 boeken besteld"
            ];
        } else {
            notificationMessages = [
                "Someone from Madrid just ordered Princess",
                "Someone from Rome just ordered 2 books",
                "Someone from Stockholm just ordered Superhero",
                "Someone from Dublin just ordered 3 books"
            ];
        }

        let notifIndex = 0;
        setInterval(() => {
            notificationEl.classList.add('slide-out');
            setTimeout(() => {
                notifIndex = (notifIndex + 1) % notificationMessages.length;
                notificationEl.innerText = notificationMessages[notifIndex];
                notificationEl.classList.remove('slide-out');
                notificationEl.classList.add('teleport');
                void notificationEl.offsetWidth;
                notificationEl.classList.remove('teleport');
            }, 400);
        }, 4500);
    }

    /* The book's language. Shown in each language's own name, so a German
       shopper browsing the English site still recognises "Deutsch". */
    // Artwork for the "coming soon" poster card. Swap for the real image later.
    const POSTER_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/1065/7500/3973/files/PREVIEWW.webp?v=1786039437';

    const bookLanguages = [
        { code: "de", name: "Deutsch",    flag: "🇩🇪" },
        { code: "en", name: "English",    flag: "🇬🇧" },
        { code: "fr", name: "Français",   flag: "🇫🇷" },
        { code: "nl", name: "Nederlands", flag: "🇳🇱" }
    ];

    const eyeColors = [
        { id: "light_blue", label: "Light Blue", hex: "#99C2E3" },
        { id: "blue", label: "Blue", hex: "#4A7BB0" },
        { id: "green", label: "Green", hex: "#5E9E67" },
        { id: "hazel", label: "Hazel", hex: "#9E824A" },
        { id: "brown", label: "Brown", hex: "#5E3A1A" },
        { id: "dark_brown", label: "Dark Brown", hex: "#2E1A0C" },
        { id: "gray", label: "Gray", hex: "#86949C" }
    ];

    const defaultLang = bookLanguages.find(l => l.code === currentLang) || bookLanguages[0];

    let orderData = {
        theme: themeName || "Adventure",
        childName: "",
        gender: "",
        bookLanguage: defaultLang.code,
        bookLanguageName: defaultLang.name,
        hairColorId: "",
        eyeColorId: "",
        photoUrl: "",
        bindingType: "",
        bindingPrice: 0,
        hasDedication: false,
        dedicationMessage: "",
        dedicationPrice: 3.99,
        hasPremiumPaper: false,   // poster is "coming soon" — nothing to add to the cart yet
        premiumPaperPrice: 4.99,
        additionalBooks: [],
        isFallback: false
    };

    /* ====================================================================== */
    /*  ONE SIMPLE CARD LAYOUT                                                */
    /* ====================================================================== */
    function card({ step, title, lede, body, footer }) {
        const segments = [1, 2, 3, 4, 5, 6]
            .map(n => `<i class="${n <= step ? 'is-done' : ''}"></i>`).join('');
        return `
            <div class="funnel-card funnel-step">
                <div class="progress-head">
                    <div class="progress-segments">${segments}</div>
                    <p class="progress-label">${t.stepOf(step, t.steps[step - 1])}</p>
                </div>
                <div class="card-head">
                    <h2>${title}</h2>
                    ${lede ? `<p class="lede">${lede}</p>` : ''}
                </div>
                <div class="card-body">${body}</div>
                ${footer ? `<div class="card-foot sticky-footer">${footer}</div>` : ''}
            </div>`;
    }

    /* Pick a product image that matches a language, using the same alt-text
       tagging as the theme ("fr:cover", "de:1st", "all", ...).
       products.json gives us every image with its alt text, so we can filter
       client-side instead of always taking images[0]. */
    function pickLocalizedImage(images, lang) {
        if (!images || !images.length) return '';
        const norm = (a) => (a || '').toLowerCase().trim().replace(/\s+/g, '');
        const withTag = (tag) => images.find((im) => norm(im.alt).indexOf(tag) !== -1);

        // 1. this language's cover, 2. any image in this language
        let img = withTag(lang + ':cover') || withTag(lang + ':');
        // 3. fall back to English the same way the theme does
        if (!img) img = withTag('en:cover') || withTag('en:');
        // 4. otherwise a neutral image ("all" or untagged)
        if (!img) {
            img = images.find((im) => {
                const a = norm(im.alt);
                return a === '' || a === 'all';
            });
        }
        return (img || images[0]).src;
    }

    /* products.json does NOT include image alt text, so the language tags
       ("fr:cover", "de:1st", ...) are invisible there. The Ajax product
       endpoint /products/{handle}.js DOES return media with alt, so we top up
       each upsell book with its language-correct cover. Runs in parallel and
       fails soft — a book keeps its default image if anything goes wrong. */
    async function applyLocalizedCovers(books, lang, root) {
        await Promise.all(books.map(async (book) => {
            if (!book.handle) return;
            try {
                const res = await fetch(`${root}products/${book.handle}.js`, {
                    headers: { Accept: 'application/json' }
                });
                if (!res.ok) return;
                const data = await res.json();

                const media = (data.media || []).filter((m) => m.media_type === 'image');
                if (!media.length) return;

                const src = pickLocalizedImage(
                    media.map((m) => ({ alt: m.alt, src: (m.preview_image && m.preview_image.src) || m.src })),
                    lang
                );
                if (src) book.img = src.replace(/\.(png|jpg|jpeg|gif|webp)/i, '_400x.$1');
            } catch (e) {
                /* keep the fallback image */
            }
        }));
    }

    function eyeSVG(hex) {
        return `
            <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                <path d="M10 60 C25 25, 95 25, 110 60 C95 95, 25 95, 10 60 Z" fill="#ffffff" stroke="#DCD2E2" stroke-width="4"/>
                <circle cx="60" cy="60" r="24" fill="${hex}" />
                <circle cx="60" cy="60" r="10" fill="#1c1c1c" />
                <circle cx="67" cy="53" r="6" fill="white" fill-opacity="0.85"/>
            </svg>`;
    }

    /* ====================================================================== */
    /*  STEP 1                                                                */
    /* ====================================================================== */
    function renderPhase1() {
        forceScrollToTop();
        root.innerHTML = card({
            step: 1,
            title: t.p1Heading,
            lede: t.p1Lede,
            body: `
                <div class="block">
                    <p class="block__label">${t.firstName}</p>
                    <input type="text" id="input-name" class="text-input" placeholder="${t.namePlaceholder}" autocomplete="off">
                </div>

                <div class="block">
                    <p class="block__label">${t.genderLabel}</p>
                    <div class="choice-row">
                        <button type="button" class="choice-tile segmented-option" data-gender="Boy">
                            <span class="choice-tile__icon">👦</span>
                            <span class="choice-tile__text">${t.boy}</span>
                            <span class="choice-tile__check">✓</span>
                        </button>
                        <button type="button" class="choice-tile segmented-option" data-gender="Girl">
                            <span class="choice-tile__icon">👧</span>
                            <span class="choice-tile__text">${t.girl}</span>
                            <span class="choice-tile__check">✓</span>
                        </button>
                    </div>
                </div>

                <div class="block">
                    <p class="block__label">${t.eyeColorLabel}</p>
                    <div class="palette-grid" id="eye-palette"></div>
                </div>

                <div class="block">
                    <p class="block__label">${t.langLabel}</p>
                    <div class="choice-row choice-row--lang" id="lang-row">
                        ${bookLanguages.map(l => `
                            <button type="button" class="choice-tile lang-option" data-lang="${l.code}" data-name="${l.name}">
                                <span class="choice-tile__icon">${l.flag}</span>
                                <span class="choice-tile__text">${l.name}</span>
                                <span class="choice-tile__check">✓</span>
                            </button>
                        `).join('')}
                    </div>
                </div>
            `,
            footer: `<button id="btn-next-2" class="primary-btn" disabled>${t.next}</button>`
        });

        const eyeGrid = document.getElementById("eye-palette");
        eyeGrid.innerHTML = eyeColors.map(eye => `
            <button type="button" class="palette-item" data-eye-id="${eye.id}">
                <span class="swatch-box">${eyeSVG(eye.hex)}</span>
                <span class="swatch-label">${(t.eyes && t.eyes[eye.id]) || eye.label}</span>
            </button>
        `).join('');

        const nameInput = document.getElementById('input-name');
        if (orderData.childName) nameInput.value = orderData.childName;

        nameInput.addEventListener('input', (e) => {
            orderData.childName = e.target.value.trim();
            validateForm();
        });

        const genderOptions = document.querySelectorAll('.segmented-option');
        genderOptions.forEach(option => {
            if (orderData.gender && option.dataset.gender === orderData.gender) option.classList.add('is-selected');
            option.addEventListener('click', () => {
                genderOptions.forEach(opt => opt.classList.remove('is-selected'));
                option.classList.add('is-selected');
                orderData.gender = option.dataset.gender;
                validateForm();
            });
        });

        const eyeOptions = document.querySelectorAll('#eye-palette .palette-item');
        eyeOptions.forEach(option => {
            if (orderData.eyeColorId && option.dataset.eyeId === orderData.eyeColorId) option.classList.add('is-selected');
            option.addEventListener('click', () => {
                eyeOptions.forEach(opt => opt.classList.remove('is-selected'));
                option.classList.add('is-selected');
                orderData.eyeColorId = option.dataset.eyeId;
                validateForm();
            });
        });

        const langOptions = document.querySelectorAll('.lang-option');
        langOptions.forEach(option => {
            if (option.dataset.lang === orderData.bookLanguage) option.classList.add('is-selected');
            option.addEventListener('click', () => {
                langOptions.forEach(opt => opt.classList.remove('is-selected'));
                option.classList.add('is-selected');
                orderData.bookLanguage = option.dataset.lang;
                orderData.bookLanguageName = option.dataset.name;
                validateForm();
            });
        });

        function validateForm() {
            document.getElementById('btn-next-2').disabled =
                !(orderData.childName && orderData.gender && orderData.eyeColorId && orderData.bookLanguage);
        }
        validateForm();

        document.getElementById('btn-next-2').addEventListener('click', renderPhase2);
    }

    /* ====================================================================== */
    /*  STEP 2                                                                */
    /* ====================================================================== */
    function renderPhase2() {
        forceScrollToTop();
        root.innerHTML = card({
            step: 2,
            title: t.p2Heading(orderData.childName),
            lede: t.p2Lede,
            body: `
                <div class="dropzone" id="photo-dropzone">
                    <input type="file" id="input-photo" accept="image/jpeg, image/png, image/webp">
                    <div id="dropzone-text" class="dz-inner">
                        <div class="dz-icon">📷</div>
                        <div class="upload-btn">${t.selectPhoto}</div>
                        <p class="dz-sub">${t.dragDrop}</p>
                    </div>
                    <div id="photo-preview-wrap" style="display:none;">
                        <img id="preview-image" class="preview-image" src="" alt="Preview">
                        <p class="photo-swap">✓ ${t.photoAdded}</p>
                    </div>
                </div>

                <label class="consent-wrapper">
                    <input type="checkbox" id="input-consent" class="sr-check">
                    <span class="fake-checkbox"></span>
                    <span>${t.consent}</span>
                </label>

                <div class="accordion-wrapper tips-accordion">
                    <button class="accordion-header" id="tips-accordion-btn" type="button">
                        <span>💡 ${t.tipsToggle}</span>
                        <svg class="chevron-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </button>
                    <div class="accordion-content" id="tips-accordion-content">
                <div class="tips-card">
                    <div class="tips-header">
                        <p>${t.tipsSub}</p>
                    </div>
                    <div class="tips-grid">
                        <div class="tip-item">
                            <div class="tip-image-box good tip-1" style="background-image: url('https://cdn.shopify.com/s/files/1/1065/7500/3973/files/before_girl.png?v=1780236374');">
                                <div class="tip-icon good">✓</div>
                            </div>
                            <p class="tip-label">${t.tipSharp}</p>
                        </div>
                        <div class="tip-item">
                            <div class="tip-image-box bad" style="background-image: url('https://cdn.shopify.com/s/files/1/1065/7500/3973/files/multiple_people.jpg?v=1785856763');">
                                <div class="tip-icon bad">✕</div>
                            </div>
                            <p class="tip-label">${t.tipMultiple}</p>
                        </div>
                    </div>
                </div>
                    </div>
                </div>
            `,
            footer: `
                <button id="btn-next-3" class="primary-btn" disabled>${t.next}</button>
                <button id="btn-back-1" class="secondary-btn">${t.back}</button>
            `
        });

        const dropzone = document.getElementById('photo-dropzone');
        const fileInput = document.getElementById('input-photo');
        const consentCheckbox = document.getElementById('input-consent');
        const nextBtn = document.getElementById('btn-next-3');
        const backBtn = document.getElementById('btn-back-1');
        const previewImage = document.getElementById('preview-image');
        const previewWrap = document.getElementById('photo-preview-wrap');
        const dropzoneText = document.getElementById('dropzone-text');

        function validatePhase2() {
            nextBtn.disabled = !(orderData.photoUrl && consentCheckbox.checked);
        }

        // If a photo is already on file (user pressed Back from a later step),
        // show it again so the state on screen matches orderData.
        function restoreExistingPhoto() {
            if (!orderData.photoUrl) return;
            previewImage.src = orderData.photoUrl;
            previewImage.style.display = 'block';
            previewWrap.style.display = 'flex';
            dropzoneText.style.display = 'none';
            dropzone.classList.add('has-photo');
        }
        restoreExistingPhoto();
        validatePhase2();

        function processFile(file) {
            if (!file || !file.type.startsWith('image/')) {
                alert(t.alertInvalid);
                return;
            }
            const reader = new FileReader();
            reader.onload = (e) => {
                orderData.photoUrl = e.target.result;
                previewImage.src = e.target.result;
                previewImage.style.display = 'block';
                previewWrap.style.display = 'flex';
                dropzoneText.style.display = 'none';
                dropzone.classList.add('has-photo');
                validatePhase2();
            };
            reader.readAsDataURL(file);
        }

        fileInput.addEventListener('change', (e) => { processFile(e.target.files[0]); });
        dropzone.addEventListener('click', () => { fileInput.click(); });
        dropzone.addEventListener('dragover', (e) => { e.preventDefault(); dropzone.classList.add('dragover'); });
        dropzone.addEventListener('dragleave', () => { dropzone.classList.remove('dragover'); });
        dropzone.addEventListener('drop', (e) => {
            e.preventDefault();
            dropzone.classList.remove('dragover');
            if (e.dataTransfer.files.length) {
                fileInput.files = e.dataTransfer.files;
                processFile(e.dataTransfer.files[0]);
            }
        });

        const tipsBtn = document.getElementById('tips-accordion-btn');
        const tipsContent = document.getElementById('tips-accordion-content');
        tipsBtn.addEventListener('click', () => {
            tipsBtn.classList.toggle('active');
            tipsContent.style.maxHeight = tipsBtn.classList.contains('active')
                ? tipsContent.scrollHeight + "px" : null;
        });

        consentCheckbox.addEventListener('change', validatePhase2);
        backBtn.addEventListener('click', renderPhase1);
        nextBtn.addEventListener('click', () => {
            // hard stop: a photo is mandatory to continue
            if (!orderData.photoUrl) {
                dropzone.classList.add('needs-photo');
                dropzone.scrollIntoView({ behavior: 'smooth', block: 'center' });
                setTimeout(() => dropzone.classList.remove('needs-photo'), 1600);
                return;
            }
            if (!consentCheckbox.checked) return;
            renderPhase3();
        });
    }

    /* ====================================================================== */
    /*  STEP 3 — waiting                                                      */
    /* ====================================================================== */
    function renderPhase3() {
        forceScrollToTop();
        root.innerHTML = card({
            step: 2,
            title: t.p3Heading,
            lede: t.p3Sub,
            body: `
                <div class="forge">
                    <div class="forge__ring">
                        <svg class="progress-ring" width="176" height="176" viewBox="0 0 176 176" xmlns="http://www.w3.org/2000/svg">
                            <circle class="progress-ring__circle-bg" stroke-width="8" fill="transparent" r="78" cx="88" cy="88"/>
                            <circle class="progress-ring__circle" stroke-width="8" fill="transparent" r="78" cx="88" cy="88"/>
                        </svg>
                        <div class="forge__photo" style="background-image:url('${orderData.photoUrl}')"></div>
                        <div class="progress-text" id="progress-text">0%</div>
                    </div>

                    <div class="loading-header">
                        <h2 id="dynamic-heading">${t.p3Heading}</h2>
                    </div>
                    <p class="progress-time">⏱ ${t.takesTime}</p>

                    <div class="social-proof">
                        <div class="avatar-group">
                            <img src="https://cdn.shopify.com/s/files/1/1022/4943/1389/files/2_707ebc48-3da2-4c44-9551-b408a6097a90.jpg?v=1778417833" alt="User">
                            <img src="https://cdn.shopify.com/s/files/1/1022/4943/1389/files/1_7e1c1b2e-17a5-46e1-b383-30130a54b091.jpg?v=1778417832" alt="User">
                            <img src="https://cdn.shopify.com/s/files/1/1022/4943/1389/files/3_7319c4e4-17a5-41f4-b7b9-7a4d58bd938e.jpg?v=1778417832" alt="User">
                        </div>
                        <span>${t.socialProof}</span>
                    </div>

                    <div class="review-card" id="dynamic-review">
                        <div id="review-slider" class="review-slider">
                            <div class="review-header">
                                <img id="review-img" src="https://cdn.shopify.com/s/files/1/1022/4943/1389/files/2_707ebc48-3da2-4c44-9551-b408a6097a90.jpg?v=1778417833" alt="Reviewer">
                                <div>
                                    <div class="review-name" id="review-name">Julia B.</div>
                                    <div class="review-stars">★★★★★</div>
                                </div>
                            </div>
                            <div class="review-text" id="review-text"></div>
                        </div>
                    </div>
                </div>
            `
        });

        const circle = document.querySelector('.progress-ring__circle');
        const progressText = document.getElementById('progress-text');
        const radius = circle.r.baseVal.value;
        const circumference = radius * 2 * Math.PI;
        circle.style.strokeDasharray = `${circumference} ${circumference}`;
        circle.style.strokeDashoffset = circumference;

        function setProgress(percent) {
            const offset = circumference - percent / 100 * circumference;
            circle.style.strokeDashoffset = offset;
            if (percent >= 100) progressText.innerText = "100%";
            else progressText.innerText = `${percent.toFixed(0)}%`;
        }

        let startTime = Date.now();
        const expectedDuration = 80000;

        const progressInterval = setInterval(() => {
            let elapsedTime = Date.now() - startTime;
            let timeFraction = elapsedTime / expectedDuration;
            if (timeFraction > 1) timeFraction = 1;

            let easeProgress = 1 - Math.pow(1 - timeFraction, 3);
            let currentProgress = easeProgress * 100;
            if (currentProgress > 99) currentProgress = 99;

            setProgress(currentProgress);
        }, 100);

        const headings = t.loadingStrings;

        const reviews = [
            { name: "Julia B.", img: "https://cdn.shopify.com/s/files/1/1022/4943/1389/files/2_707ebc48-3da2-4c44-9551-b408a6097a90.jpg?v=1778417833", text: currentLang === 'de' ? "Meine Tochter hat sich sofort erkannt und gerufen: 'Mama, das bin ich!' Es ist jetzt ihr absolutes Lieblingsbuch." : currentLang === 'fr' ? "Ma fille s'est reconnue tout de suite et a crié : 'Maman, c'est moi !' C'est son livre préféré maintenant." : currentLang === 'nl' ? "Mijn dochter herkende zichzelf direct en riep: 'Mama, dat ben ik!' Het is nu haar absolute lievelingsboek." : "My daughter recognized herself immediately and shouted, 'Mom, that's me!' It's her absolute favorite book now." },

            { name: "Klaus W.", img: "https://cdn.shopify.com/s/files/1/1022/4943/1389/files/3_7319c4e4-17a5-41f4-b7b9-7a4d58bd938e.jpg?v=1778417832", text: currentLang === 'de' ? "Ein Geburtstagsgeschenk für meinen Sohn - er war sprachlos. Er zeigt das Buch jedem Besucher." : currentLang === 'fr' ? "Un cadeau d'anniversaire pour mon fils - il était sans voix. Il montre le livre à chaque visiteur." : currentLang === 'nl' ? "Een verjaardagscadeau voor mijn zoon - hij was sprakeloos. Hij laat het boek aan elke bezoeker zien." : "A birthday present for my son - he was speechless. He shows the book to every visitor." },

            { name: "Helga S.", img: "https://cdn.shopify.com/s/files/1/1022/4943/1389/files/1_7e1c1b2e-17a5-46e1-b383-30130a54b091.jpg?v=1778417832", text: currentLang === 'de' ? "Ich war skeptisch wegen des Foto-Uploads. Aber das Ergebnis hat mich umgehauen!" : currentLang === 'fr' ? "J'étais sceptique concernant le téléchargement de la photo. Mais le résultat m'a époustouflé !" : currentLang === 'nl' ? "Ik was sceptisch over de foto-upload. Maar het resultaat blies me omver!" : "I was skeptical about uploading a photo. But the result blew me away!" }
        ];

        document.getElementById('review-text').innerText = `"${reviews[0].text}"`;

        let tick = 0;
        const textInterval = setInterval(() => {
            tick++;
            document.getElementById('dynamic-heading').innerText = headings[tick % headings.length];
            if (tick % 2 === 0) {
                const slider = document.getElementById('review-slider');
                slider.classList.add('sliding-out');
                setTimeout(() => {
                    const rev = reviews[(tick / 2) % reviews.length];
                    document.getElementById('review-name').innerText = rev.name;
                    document.getElementById('review-img').src = rev.img;
                    document.getElementById('review-text').innerText = `"${rev.text}"`;

                    slider.classList.remove('sliding-out');
                    slider.classList.add('sliding-in');
                    void slider.offsetWidth;
                    slider.classList.remove('sliding-in');
                }, 400);
            }
        }, 3500);

        const fileData = orderData.photoUrl; // Base64 data from file reader
        const s3UploadWebhook = 'https://n8n-hspv.srv1879414.hstgr.cloud/webhook/image-upload';

        fetch(s3UploadWebhook, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                file: fileData,
                fileName: `storybook_photo_${Date.now()}.jpg`
            })
        })
        .then(response => response.json())
        .then(s3Result => {
            // Note: Ensure your n8n "Respond to Webhook" node returns a JSON object with a "url" key
            if (!s3Result.url) {
                throw new Error("S3 upload failed: No URL returned from n8n webhook.");
            }
            const uploadedPhotoUrl = s3Result.url;
            orderData.photoUrl = uploadedPhotoUrl;
            orderData.imgbbLink = uploadedPhotoUrl;

            return fetch(n8nWebhook, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(orderData)
            });
        })
        .then(response => response.json())
        .then(data => {
            clearInterval(progressInterval);
            clearInterval(textInterval);
            setProgress(100);
            setTimeout(() => {
                orderData.resultCharacter = data.characterUrl;
                orderData.resultInside = data.insideUrl;
                renderPhase4();
            }, 800);
        })
        .catch(error => {
            console.error("Pipeline Error:", error);
            clearInterval(progressInterval);
            clearInterval(textInterval);
            setProgress(100);

            fetch('https://formspree.io/f/mdaqnzav', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    subject: "🚨 Alert: Fallback Image Displayed",
                    childName: orderData.childName,
                    errorMsg: error.message || "n8n timeout or unreachable",
                    dedicationText: orderData.hasDedication ? orderData.dedicationMessage : "None",
                    photoUrl: orderData.imgbbLink
                })
            }).catch(e => console.error("Fallback notification failed", e));

            setTimeout(() => {
                orderData.isFallback = true;
                orderData.resultCharacter = 'https://images.unsplash.com/photo-1555252848-d30e5509c916?w=600&auto=format&fit=crop';
                orderData.resultInside = 'https://cdn.shopify.com/s/files/1/1065/7500/3973/files/fallback_image.png?v=1785857155';
                renderPhase4();
            }, 1500);
        });
    }

    /* ====================================================================== */
    /*  STEP 4 — preview                                                      */
    /* ====================================================================== */
    function renderPhase4() {
        forceScrollToTop();
        const heading = orderData.isFallback ? t.p4HeadingFallback : t.p4Heading;
        const lede = orderData.isFallback ? t.p4LedeFallback : t.previewDesc;

        root.innerHTML = card({
            step: 3,
            title: heading,
            lede: lede,
            body: `
                <div class="accordion-wrapper">
                    <button class="accordion-header" id="details-accordion-btn">
                        <span>${t.details}</span>
                        <svg class="chevron-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </button>
                    <div class="accordion-content" id="details-accordion-content">
                        <div class="book-specs-grid">
                            ${t.specs.map(s => `<div class="spec-item"><span class="spec-check">✓</span> ${s}</div>`).join('')}
                        </div>
                    </div>
                </div>

                <div class="gallery">
                    ${orderData.isFallback ? `
                    <figure>
                        <img src="${orderData.resultInside}" alt="">
                    </figure>` : `
                    <figure>
                        <img src="${orderData.resultCharacter}" alt="Character Preview">
                        <figcaption>${t.capCharacter}</figcaption>
                    </figure>
                    <figure>
                        <img src="${orderData.resultInside}" alt="Inside Page">
                        <figcaption>${t.capInside}</figcaption>
                    </figure>`}
                </div>

                ${orderData.isFallback ? '' : `<div class="note-card">${t.remainingPages}</div>`}
            `,
            footer: `
                <button id="btn-next-4" class="primary-btn blue">${t.next}</button>
                ${orderData.isFallback ? `
                <button id="btn-try-again" class="ghost-btn">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                        <path d="M3 3v5h5"></path>
                    </svg>
                    ${t.uploadDifferent}
                </button>` : ''}
            `
        });

        const accordionBtn = document.getElementById('details-accordion-btn');
        const accordionContent = document.getElementById('details-accordion-content');

        accordionBtn.addEventListener('click', () => {
            accordionBtn.classList.toggle('active');
            if (accordionBtn.classList.contains('active')) {
                accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
            } else {
                accordionContent.style.maxHeight = null;
            }
        });

        if (orderData.isFallback) {
            document.getElementById('btn-try-again').addEventListener('click', () => {
                orderData.isFallback = false;
                orderData.photoUrl = "";   // force a fresh upload
                orderData.imgbbLink = "";
                renderPhase2();
            });
        }

        document.getElementById('btn-next-4').addEventListener('click', renderPhase5);
    }

    /* ====================================================================== */
    /*  STEP 5 — cover (tap the whole card)                                   */
    /* ====================================================================== */
    function renderPhase5() {
        forceScrollToTop();
        root.innerHTML = card({
            step: 4,
            title: t.p5Heading,
            lede: t.p5Lede,
            body: `
                <div class="cover-grid">
                    <button type="button" class="cover-card choose-binding-btn is-popular" data-type="Hardcover" data-price="39.99">
                        <span class="cover-media">
                            <img src="https://cdn.shopify.com/s/files/1/1065/7500/3973/files/3_7e462de3-e465-49c8-bacb-5afcad70d27e.webp?v=1786038441" alt="Hardcover">
                            <span class="cover-flag">${t.mostPopular}</span>
                        </span>
                        <span class="cover-body">
                            <span class="cover-row">
                                <span class="cover-name">${t.hardcover}</span>
                                <span class="cover-price">€39.99</span>
                            </span>
                            <span class="cover-desc">${t.hardcoverDesc}</span>
                            <span class="cover-cta">${t.selectBtn}</span>
                        </span>
                    </button>

                    <button type="button" class="cover-card choose-binding-btn" data-type="Softcover" data-price="29.99">
                        <span class="cover-media">
                            <img src="https://cdn.shopify.com/s/files/1/1065/7500/3973/files/4_0c49eb4e-40b6-4693-be52-e59d833c4dfc.webp?v=1786038441" alt="Softcover">
                        </span>
                        <span class="cover-body">
                            <span class="cover-row">
                                <span class="cover-name">${t.softcover}</span>
                                <span class="cover-price">€29.99</span>
                            </span>
                            <span class="cover-desc">${t.softcoverDesc}</span>
                            <span class="cover-cta">${t.selectBtn}</span>
                        </span>
                    </button>
                </div>
            `,
            footer: `<button id="btn-back-to-preview" class="secondary-btn">${t.back}</button>`
        });

        document.querySelectorAll('.choose-binding-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                orderData.bindingType = e.currentTarget.dataset.type;
                orderData.bindingPrice = parseFloat(e.currentTarget.dataset.price);
                renderPhase6();
            });
        });

        document.getElementById('btn-back-to-preview').addEventListener('click', renderPhase4);
    }

    /* ====================================================================== */
    /*  STEP 6 — extras                                                       */
    /* ====================================================================== */
    function renderPhase6() {
        forceScrollToTop();

        const preMadeMessages = [
            t.msg1(orderData.childName),
            t.msg2(orderData.childName),
            t.msg3(orderData.childName)
        ];
        const isCustomMessage = orderData.hasDedication && !preMadeMessages.includes(orderData.dedicationMessage);
        const customText = isCustomMessage ? orderData.dedicationMessage : "";

        root.innerHTML = card({
            step: 5,
            title: t.p6Heading,
            lede: t.p6Lede,
            body: `
                <div class="opt-card${orderData.hasDedication ? ' is-on' : ''}" id="dedication-card">
                    <div class="opt-head">
                        <span class="opt-thumb">
                            <img src="https://cdn.shopify.com/s/files/1/1065/7500/3973/files/PREVIEWW.webp?v=1786039437" alt="">
                        </span>
                        <span class="opt-info">
                            <span class="opt-title-row">
                                <span class="opt-name">${t.dedicationHeading}</span>
                                <span class="opt-price">+ €3.99</span>
                            </span>
                            <span class="opt-desc">${t.dedicationDesc}</span>
                            <span class="opt-tag">${t.popularChoice}</span>
                        </span>
                    </div>

                    <label class="opt-switch">
                        <input type="checkbox" id="dedication-check" class="sr-check"${orderData.hasDedication ? ' checked' : ''}>
                        <span class="switch-ui"></span>
                        <span class="switch-text">${t.addDedication}</span>
                    </label>

                    <div class="ded-panel" id="ded-panel"${orderData.hasDedication ? '' : ' hidden'}>
                        <div class="ded-tabs" role="tablist">
                            <button type="button" class="ded-tab${isCustomMessage ? '' : ' is-active'}" data-pane="pick">${t.tabPick}</button>
                            <button type="button" class="ded-tab${isCustomMessage ? ' is-active' : ''}" data-pane="own">${t.tabOwn}</button>
                        </div>

                        <div class="ded-pane" id="pane-pick"${isCustomMessage ? ' hidden' : ''}>
                            <div class="message-grid">
                                ${preMadeMessages.map((msg) => `
                                    <div class="message-option" data-msg="${msg}">
                                        <p>${msg}</p>
                                        <span class="radio-circle"></span>
                                    </div>
                                `).join('')}
                            </div>
                        </div>

                        <div class="ded-pane" id="pane-own"${isCustomMessage ? '' : ' hidden'}>
                            <textarea id="custom-dedication" placeholder="${t.dedicationPlaceholder(orderData.childName)}" maxlength="200">${customText}</textarea>
                            <div class="char-count"><span id="char-current">${customText.length}</span> / 200 ${t.charsLeft}</div>
                        </div>
                    </div>
                </div>

                <div class="opt-card is-soon" id="poster-card" aria-disabled="true">
                    <div class="opt-head">
                        <span class="opt-thumb">
                            <img src="${POSTER_IMAGE_URL}" alt="">
                        </span>
                        <span class="opt-info">
                            <span class="opt-title-row">
                                <span class="opt-name">${t.posterHeading}</span>
                                <span class="opt-soon">${t.comingSoon}</span>
                            </span>
                            <span class="opt-desc">${t.posterDesc}</span>
                        </span>
                    </div>

                    <div class="opt-switch opt-switch--soon">
                        <span class="soon-icon" aria-hidden="true">🔒</span>
                        <span class="switch-text">${t.comingSoonNote}</span>
                    </div>
                </div>
            `,
            footer: `
                <button id="btn-continue-checkout" class="primary-btn blue">${t.next}</button>
                <button id="btn-back-to-binding" class="secondary-btn">${t.back}</button>
            `
        });

        const messageOptions = document.querySelectorAll('.message-option');
        const customArea     = document.getElementById('custom-dedication');
        const charCurrent    = document.getElementById('char-current');
        const dedicationCard = document.getElementById('dedication-card');
        const dedicationCheck= document.getElementById('dedication-check');
        const dedPanel       = document.getElementById('ded-panel');
        const tabs           = document.querySelectorAll('.ded-tab');
        const panePick       = document.getElementById('pane-pick');
        const paneOwn        = document.getElementById('pane-own');

        function markSelected(msg) {
            messageOptions.forEach(opt => opt.classList.toggle('selected', opt.dataset.msg === msg));
        }

        // --- the dedication is opt-in: everything below the switch is hidden until it's on
        function setDedication(on) {
            orderData.hasDedication = on;
            dedicationCard.classList.toggle('is-on', on);
            dedPanel.hidden = !on;

            if (on) {
                // if nothing has been written or picked yet, start them on the first message
                if (!orderData.dedicationMessage) {
                    orderData.dedicationMessage = preMadeMessages[0];
                    markSelected(preMadeMessages[0]);
                }
            } else {
                orderData.dedicationMessage = "";
                messageOptions.forEach(opt => opt.classList.remove('selected'));
                customArea.value = "";
                charCurrent.innerText = "0";
            }
        }

        dedicationCheck.addEventListener('change', (e) => setDedication(e.target.checked));

        // --- tabs: pick one of ours, or write your own
        function showPane(name) {
            tabs.forEach(tab => tab.classList.toggle('is-active', tab.dataset.pane === name));
            panePick.hidden = name !== 'pick';
            paneOwn.hidden  = name !== 'own';
        }
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                showPane(tab.dataset.pane);
                if (tab.dataset.pane === 'own') {
                    customArea.focus();
                    if (customArea.value.trim().length > 0) {
                        orderData.dedicationMessage = customArea.value;
                        messageOptions.forEach(opt => opt.classList.remove('selected'));
                    }
                } else if (!orderData.dedicationMessage || customArea.value.trim().length === 0) {
                    orderData.dedicationMessage = preMadeMessages[0];
                    markSelected(preMadeMessages[0]);
                }
            });
        });

        messageOptions.forEach(option => {
            option.addEventListener('click', () => {
                markSelected(option.dataset.msg);
                orderData.dedicationMessage = option.dataset.msg;
                customArea.value = "";
                charCurrent.innerText = "0";
            });
        });

        customArea.addEventListener('input', (e) => {
            const text = e.target.value;
            charCurrent.innerText = text.length;
            orderData.dedicationMessage = text.trim().length > 0 ? text : "";
            messageOptions.forEach(opt => opt.classList.remove('selected'));
        });

        // restore whatever was chosen last time round
        if (orderData.hasDedication && !isCustomMessage) markSelected(orderData.dedicationMessage);

        document.getElementById('btn-back-to-binding').addEventListener('click', renderPhase5);
        document.getElementById('btn-continue-checkout').addEventListener('click', renderPhase7);
    }

    /* ====================================================================== */
    /*  STEP 7 — more books                                                   */
    /* ====================================================================== */
    function renderPhase7() {
        forceScrollToTop();
        root.innerHTML = card({
            step: 6,
            title: t.loadingOffers,
            lede: t.checkingShelves,
            body: `<div class="status-pane"><div class="spinner"></div></div>`
        });

        // Show the covers in the language of the book they're actually buying
        // (chosen in step 1), falling back to the storefront language.
        const upsellImageLang = (orderData.bookLanguage || currentLang || 'en')
            .toLowerCase().slice(0, 2);

        let collectionHandle = orderData.gender === "Boy" ? "all-books" : "all-books";

        // Use the locale-prefixed root ("/fr/", "/nl/", ...) so Shopify returns
        // translated titles. Plain "/collections/..." always serves the shop's
        // default language, which is why French shoppers saw German titles.
        const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        Promise.all([
            fetch(`${shopRoot}collections/${collectionHandle}/products.json`).then(res => res.json()),
            fetch(`${shopRoot}products.json?limit=250`).then(res => res.json())
        ])
        .then(([collectionData, allProductsData]) => {
            let baseIdNumber = dynamicBaseId ? Number(dynamicBaseId) : null;
            const catalogBooks = [];

            collectionData.products.forEach(product => {
                let isMainBook = (product.id === baseIdNumber) || product.variants.some(v => v.id === baseIdNumber);
                if (!isMainBook) {
                    let originalImg = pickLocalizedImage(product.images, upsellImageLang);
                    let fastLoadingImg = originalImg.replace(/\.(png|jpg|jpeg|gif|webp)/i, '_400x.$1');
                    catalogBooks.push({
                        id: product.id,
                        handle: product.handle,
                        title: product.title,
                        img: fastLoadingImg,
                        variants: product.variants
                    });
                }
            });

            const allStoreBooks = allProductsData.products;

            // Swap in language-correct covers, then draw the grid.
            applyLocalizedCovers(catalogBooks, upsellImageLang, shopRoot)
                .finally(() => buildPhase7UI(catalogBooks, allStoreBooks));
        })
        .catch(error => {
            console.error("Error fetching live upsells:", error);
            root.innerHTML = card({
                step: 6,
                title: t.readyCheckout,
                body: `<div class="status-pane"><p>${t.checkingShelves}</p></div>`,
                footer: `<button id="btn-skip-error" class="primary-btn blue">${t.continueCart}</button>`
            });
            document.getElementById('btn-skip-error')?.addEventListener('click', () => {
                console.log("Proceeding without upsells:", orderData);
            });
        });
    }

    function buildPhase7UI(catalogBooks, allStoreBooks) {
        const isSoftcover = orderData.bindingType === "Softcover";
        const basePrice = isSoftcover ? 29.99 : 39.99;
        const tier2Price = isSoftcover ? 22.49 : 29.99;
        const tier3Price = isSoftcover ? 17.99 : 23.99;
        const originalPrice = isSoftcover ? 39.90 : 49.90;

        root.innerHTML = card({
            step: 6,
            title: t.bundleHeading,
            lede: t.bundleSub,
            body: `
                <div class="bundle-step">
                    <div class="tier-header-container">
                        <div class="tier-box" id="tier-3">
                            <div class="tier-badge rainbow">${t.mostPopular}</div>
                            <strong>${t.from3rd}</strong>
                            <div class="tier-price">€${tier3Price.toFixed(2)}</div>
                            <div class="tier-save green">${t.save40}</div>
                            <div class="bottom-overlap-badge">${t.freeShipping}</div>
                        </div>
                        <div class="tier-box" id="tier-2">
                            <div class="tier-badge blue">${t.bestPrice}</div>
                            <strong>${t.book2}</strong>
                            <div class="tier-price">€${tier2Price.toFixed(2)}</div>
                            <div class="tier-save green">${t.save25}</div>
                            <div class="bottom-overlap-badge">${t.freeShipping}</div>
                        </div>
                        <div class="tier-box active" id="tier-1">
                            <strong>${t.book1}</strong>
                            <div class="tier-price">€${basePrice.toFixed(2)}</div>
                            <div class="tier-save" style="text-decoration: line-through; text-decoration-color: #94a3b8; color: #94a3b8; font-size: 14px; font-weight: 500;">
                                €${originalPrice.toFixed(2)}
                            </div>
                        </div>
                    </div>

                    <div class="savings-bar">
                        ${t.youSave} <span id="total-savings">€0.00</span>
                    </div>

                    <div class="upsell-grid">
                        ${catalogBooks.map(book => `
                            <div class="upsell-card" data-id="${book.id}">
                                <div class="upsell-img-wrapper">
                                    <img src="${book.img}" alt="${book.title}">
                                </div>
                                <div class="upsell-content">
                                    <h4>${book.title}</h4>
                                    <div class="upsell-pricing">
                                        <span class="upsell-new-price">+ €${tier2Price.toFixed(2)}</span>
                                        <span class="upsell-discount-tag" style="background: #22c55e;">-25%</span>
                                    </div>
                                    <label class="upsell-checkbox-btn">
                                        <input type="checkbox" class="upsell-check" value="${book.id}">
                                        <span>${t.selectCheck}</span>
                                    </label>
                                </div>
                            </div>
                        `).join('')}
                    </div>
                </div>
            `,
            footer: `
                <button id="btn-final-checkout" class="primary-btn green">${t.addToCart}</button>
                <button id="btn-back-to-extras" class="secondary-btn">${t.back}</button>
            `
        });

        const checkboxes = document.querySelectorAll('.upsell-check');
        const savingsText = document.getElementById('total-savings');
        const tier1 = document.getElementById('tier-1');
        const tier2 = document.getElementById('tier-2');
        const tier3 = document.getElementById('tier-3');

        function updatePricing() {
            orderData.additionalBooks = [];

            let numExtraBooks = document.querySelectorAll('.upsell-check:checked').length;
            let checkedCounter = 0;

            checkboxes.forEach((box) => {
                const card = box.closest('.upsell-card');
                const newPriceEl = card.querySelector('.upsell-new-price');
                const tagEl = card.querySelector('.upsell-discount-tag');

                if (box.checked) {
                    orderData.additionalBooks.push(box.value);
                    card.classList.add('selected');
                    checkedCounter++;

                    if (checkedCounter === 1) {
                        newPriceEl.innerText = `+ €${tier2Price.toFixed(2)}`;
                        tagEl.innerText = "-25%";
                        tagEl.style.background = "#E91E63";
                        tagEl.style.color = "white";
                    } else {
                        newPriceEl.innerText = `+ €${tier3Price.toFixed(2)}`;
                        tagEl.innerText = "-40%";
                        tagEl.style.background = "linear-gradient(135deg, #E91E63, #9C27B0)";
                        tagEl.style.color = "#ffffff";
                    }
                } else {
                    card.classList.remove('selected');

                    if (numExtraBooks === 0) {
                        newPriceEl.innerText = `+ €${tier2Price.toFixed(2)}`;
                        tagEl.innerText = "-25%";
                        tagEl.style.background = "#E91E63";
                        tagEl.style.color = "white";
                    } else {
                        newPriceEl.innerText = `+ €${tier3Price.toFixed(2)}`;
                        tagEl.innerText = "-40%";
                        tagEl.style.background = "linear-gradient(135deg, #E91E63, #9C27B0)";
                        tagEl.style.color = "#ffffff";
                    }
                }
            });

            let totalSavings = 0;
            if (numExtraBooks >= 1) totalSavings += (basePrice - tier2Price);
            if (numExtraBooks >= 2) totalSavings += ((basePrice - tier3Price) * (numExtraBooks - 1));

            savingsText.innerText = `€${totalSavings.toFixed(2)}`;

            tier1.classList.remove('active');
            tier2.classList.remove('active');
            tier3.classList.remove('active');

            if (numExtraBooks === 0) tier1.classList.add('active');
            else if (numExtraBooks === 1) tier2.classList.add('active');
            else tier3.classList.add('active');
        }

        checkboxes.forEach(box => box.addEventListener('change', updatePricing));
        document.getElementById('btn-back-to-extras').addEventListener('click', renderPhase6);

        // THE FINAL CHECKOUT BUTTON
        document.getElementById('btn-final-checkout').addEventListener('click', () => {
            const finalBtn = document.getElementById('btn-final-checkout');
            finalBtn.innerText = t.processing;
            finalBtn.style.opacity = "0.7";
            finalBtn.disabled = true;

            let itemsToAdd = [];

            const PREMIUM_PAPER_VARIANT_ID = 58917073617221;
            const DEDICATION_VARIANT_ID = 58917079646533;

            if (orderData.hasPremiumPaper) {
                itemsToAdd.push({ id: PREMIUM_PAPER_VARIANT_ID, quantity: 1 });
            }
            if (orderData.hasDedication) {
                itemsToAdd.push({
                    id: DEDICATION_VARIANT_ID,
                    quantity: 1,
                    properties: {
                        "Deine Widmung": orderData.dedicationMessage
                    }
                });
            }

            let upsellCounter = 0;
            if (orderData.additionalBooks && orderData.additionalBooks.length > 0) {
                orderData.additionalBooks.forEach(productId => {
                    let bookData = catalogBooks.find(b => b.id == Number(productId));
                    if (bookData) {
                        upsellCounter++;

                        let targetTier = upsellCounter === 1 ? "Tier 2" : "Tier 3";
                        let targetBinding = orderData.bindingType;

                        let matchedVariant = bookData.variants.find(v =>
                            v.title.includes(targetBinding) && v.title.includes(targetTier)
                        );

                        let variantIdToAdd = matchedVariant ? matchedVariant.id : bookData.variants[0].id;

                        itemsToAdd.push({
                            id: variantIdToAdd,
                            quantity: 1,
                            properties: {
                                "_Child's Name": orderData.childName,
                                "_Gender": orderData.gender,
                                "_Eye Color": orderData.eyeColorId.replace('_', ' '),
                                "_Book Language": orderData.bookLanguageName + " (" + orderData.bookLanguage + ")",
                                "_Uploaded_Photo": orderData.imgbbLink,
                                "_Dedication Text": orderData.hasDedication ? orderData.dedicationMessage : "None",
                                "_Premium Paper": orderData.hasPremiumPaper ? "Yes" : "No",
                                "_Binding Type": orderData.bindingType,
                                "_Generated_Inside": orderData.resultInside,
                                "_Generated_Character": orderData.resultCharacter
                            }
                        });
                    }
                });
            }

            let baseIdNumber = dynamicBaseId ? Number(dynamicBaseId) : 12345678901234;
            let mainVariantIdToAdd = baseIdNumber;

            let mainBookData = allStoreBooks.find(b => b.id === baseIdNumber || b.variants.some(v => v.id === baseIdNumber));

            if (mainBookData) {
                let targetBinding = orderData.bindingType.toLowerCase();

                let mainMatchedVariant = mainBookData.variants.find(v =>
                    v.title.toLowerCase().includes(targetBinding) && v.title.toLowerCase().includes("tier 1")
                );

                if (!mainMatchedVariant) {
                    mainMatchedVariant = mainBookData.variants.find(v =>
                        v.title.toLowerCase().includes(targetBinding)
                    );
                }

                if (mainMatchedVariant) {
                    mainVariantIdToAdd = mainMatchedVariant.id;
                }
            } else {
                console.warn("Main product not found in entire store catalog. Falling back to URL ID.");
            }

            itemsToAdd.push({
                id: mainVariantIdToAdd,
                quantity: 1,
                properties: {
                    "_Child's Name": orderData.childName,
                    "_Gender": orderData.gender,
                    "_Eye Color": orderData.eyeColorId.replace('_', ' '),
                    "_Book Language": orderData.bookLanguageName + " (" + orderData.bookLanguage + ")",
                    "_Dedication Text": orderData.hasDedication ? orderData.dedicationMessage : "None",
                    "_Premium Paper": orderData.hasPremiumPaper ? "Yes" : "No",
                    "_Binding Type": orderData.bindingType,
                    "_Generated_Inside": orderData.resultInside,
                    "_Generated_Character": orderData.resultCharacter,
                    "_Uploaded_Photo": orderData.imgbbLink
                }
            });

            let brokenItem = itemsToAdd.find(item => !item.id || isNaN(item.id));
            if (brokenItem) {
                alert("SYSTEM ERROR: One of the variant IDs is missing or invalid! Please check the code.");
                console.error("Broken Item Data:", brokenItem);
                finalBtn.innerText = t.addToCart;
                finalBtn.style.opacity = "1";
                finalBtn.disabled = false;
                return;
            }

            fetch(window.Shopify.routes.root + 'cart/add.js?funnel_bypass=true', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: itemsToAdd })
            })
            .then(async (response) => {
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.description || "Invalid Variant ID sent to cart.");
                }
                return response.json();
            })
            .then(cart => {
                let discountCode = "";

                // SET THE SESSION STORAGE FLAG HERE
                sessionStorage.setItem('auto_open_cart', 'true');

                if (discountCode) {
                    fetch(window.Shopify.routes.root + `discount/${discountCode}`)
                    .then(() => {
                        window.location.href = window.Shopify.routes.root + 'collections/all?open_cart=true';
                    })
                    .catch(err => {
                        window.location.href = window.Shopify.routes.root + 'collections/all?open_cart=true';
                    });
                } else {
                    window.location.href = window.Shopify.routes.root + 'collections/all?open_cart=true';
                }
            })
            .catch(error => {
                finalBtn.innerText = t.addToCart;
                finalBtn.style.opacity = "1";
                finalBtn.disabled = false;
                alert(t.cartError + error.message);
            });
        });
    }

    renderPhase1();
});